import React from 'react';
import { useTranslation } from 'react-i18next';
import { DateInput, Switch } from '@origo/origo-ui';
import type { PlanInfoFormValues } from '../../../types';
import PageSection from '../../../components/PageSection';
import layout from './PlanInfoLayout.module.css';
import styles from './DecisionSection.module.css';

type DateField = 'vedtaksdato' | 'vedtakEndeligPlanDato' | 'ikrafttredelsesdato' | 'kunngjoringsdato';
type FlagField = 'ubehandletKlage' | 'ubehandletInnsigelse';

interface DecisionSectionProps {
    values: Pick<PlanInfoFormValues, DateField | FlagField>;
    errors?: Partial<Record<DateField | FlagField, string>>;
    onChange: <K extends DateField | FlagField>(field: K, value: PlanInfoFormValues[K]) => void;
}

const DecisionSection: React.FC<DecisionSectionProps> = ({ values, errors = {}, onChange }) => {
    const { t } = useTranslation();

    const dateInput = (field: DateField) => (
        <DateInput
            label={t(`planInfo.fields.${field}`)}
            value={values[field]}
            error={errors[field]}
            onChange={e => onChange(field, e.target.value)}
        />
    );

    return (
        <PageSection title={t('planInfo.sections.decision')} asFieldset>
            <div className={layout.twoColumn}>
                {dateInput('vedtaksdato')}
                {dateInput('vedtakEndeligPlanDato')}
            </div>
            <div className={layout.twoColumn}>
                {dateInput('ikrafttredelsesdato')}
                {dateInput('kunngjoringsdato')}
            </div>
            <div className={styles.flags}>
                <Switch
                    label={t('planInfo.fields.ubehandletKlage')}
                    labelPosition="right"
                    className={layout.switch}
                    checked={values.ubehandletKlage}
                    onChange={v => onChange('ubehandletKlage', v)}
                />
                <Switch
                    label={t('planInfo.fields.ubehandletInnsigelse')}
                    labelPosition="right"
                    className={layout.switch}
                    checked={values.ubehandletInnsigelse}
                    onChange={v => onChange('ubehandletInnsigelse', v)}
                />
            </div>
        </PageSection>
    );
};

export default DecisionSection;
